import React from 'react';

import { Skeleton, SkeletonSize } from './Skeleton';

export const SkeletonRow: React.FC<{ size?: string }> = ({ size }) => {
    return (
        <tr className='h-[72px] border-b border-gray-300'>
            <td className='pl-6'>
                <div className='flex items-center'>
                    {size !== 'small' && <Skeleton size={SkeletonSize.Avatar} />}
                    <div className='flex flex-col gap-2 ml-3'>
                        <Skeleton size={SkeletonSize.Default} />
                        <Skeleton size={SkeletonSize.Small} />
                    </div>
                </div>
            </td>
            <td>
                <div className='flex flex-col gap-2'>
                    <Skeleton size={SkeletonSize.Default} />
                    <Skeleton size={SkeletonSize.Small} />
                </div>
            </td>
            <td>
                <div className='flex flex-col gap-2'>
                    <Skeleton size={SkeletonSize.Default} />
                    <Skeleton size={SkeletonSize.Small} />
                </div>
            </td>
            <td>
                <div className='flex flex-col gap-2'>
                    <Skeleton size={SkeletonSize.Default} />
                    <Skeleton size={SkeletonSize.Small} />
                </div>
            </td>
            {size !== 'small' && (
                <>
                    <td>
                        <div className='flex flex-col gap-2'>
                            <Skeleton size={SkeletonSize.Button} />
                        </div>
                    </td>
                </>
            )}
        </tr>
    );
};
